export const fragmentCollectionSimpleQuery = `
{
  relationTo
  value {
    ... on Page {
      id
      slug
      title
      group {
        docs {
          id
        }
      }
    }
    ... on Programme {
      id
      slug
      title
      type {
        slug
      }
    }
    ... on ProgrammeType {
      id
      slug
      title
    }
    ... on News {
      id
      slug
      title
    }
    ... on Person {
      id
      slug
      title
    }
    ... on GlobalPage {
      id
      title
      globalType
    }
  }
}
`
